import { selector } from 'lib/selectors';

export const routing = (state) => state.routing;
export const locationSelector = selector(routing, (r) => r.get('location'));
export const locationKeySelector = selector(routing, (r) => r.getIn(['location', 'key']));
export const searchSelector = selector(locationSelector, (r) => r.get('search'));
export const querySelector = selector(locationSelector, (l) => l.query);
export const stateSelector = selector(locationSelector, (r) => r.get('state'));
export const backUrlSelector = selector(stateSelector, (r) => r.get('backUrl'));
export const prevLocationSelector = selector(routing, (r) => r.get('prevLocation'));
export const routerCompleteHashSelector = selector(routing, (r) => r.complete);
export const prevQuerySelector = selector(prevLocationSelector, (l) => l.query);

export const locationIsChange = selector(prevLocationSelector, locationSelector, (prev, current) => {
  if (prev.pathname !== current.pathname) return true;
  // think of using key === default
  return prev.search !== current.search || prev.key !== current.key;
});
